import {useFormContext} from '@yandex-delivery/form'
import {useCallback, useState} from 'react'

export function useReturnPointModal() {
  const {setFieldValue, resetField} = useFormContext()
  const [isReturnPointModalOpen, setIsReturnModalOpen] = useState(false)

  const openReturnPointModal = useCallback(() => {
    setIsReturnModalOpen(true)
  }, [])

  const closeReturnPointModalHandler = useCallback(() => {
    setIsReturnModalOpen(false)
    // Устанавливаем изначальное значение
    setFieldValue('returnPoint', undefined)
    // Сбрасываем состояние поля
    resetField('returnPoint')
  }, [resetField, setFieldValue])

  const acceptReturnPointModalHandler = useCallback(() => {
    setIsReturnModalOpen(false)
  }, [])

  return {
    isReturnPointModalOpen,
    openReturnPointModal,
    closeReturnPointModalHandler,
    acceptReturnPointModalHandler,
  }
}
